import Vue from "vue";

export function CopySuccessToastController () {
    this.title = '';
    // this.message = '';
    this.busModal = new Vue();

    //#region setter
    this.setTitle = function(title) {
        this.title = title;
        return this;
    };
    // this.setMessage = function(message) {
    //     this.message = message;
    //     return this;
    // };
    this.clearToast = function() {
        this.title = '';
        // this.message = '';
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            title: this.title,
            // message: this.message,
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function() {
        this.busModal.$emit('hide');
    };
    //#endregion method
}

